var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMood(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dii_3417_109085)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2.08984,
    y: 1.64258,
    width: 16.7143,
    height: 16.7143,
    rx: 8.35714,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4453 13.2422C12.2402 13.2422 13.6953 11.7871 13.6953 9.99219C13.6953 8.19726 12.2402 6.74219 10.4453 6.74219C8.65039 6.74219 7.19531 8.19726 7.19531 9.99219C7.19531 11.7871 8.65039 13.2422 10.4453 13.2422Z",
    fill: "#838383"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.447 15.0824C10.1916 15.0824 9.9827 14.8921 9.9827 14.6367V14.5996C9.9827 14.3442 10.1916 14.1353 10.447 14.1353C10.7023 14.1353 10.9113 14.3442 10.9113 14.5996C10.9113 14.8549 10.7023 15.0824 10.447 15.0824ZM13.762 13.7731C13.6413 13.7731 13.5252 13.7267 13.4323 13.6385L13.372 13.5781C13.1909 13.3971 13.1909 13.1046 13.372 12.9235C13.5531 12.7424 13.8456 12.7424 14.0266 12.9235L14.087 12.9839C14.2681 13.1649 14.2681 13.4574 14.087 13.6385C13.9988 13.7267 13.8827 13.7731 13.762 13.7731ZM7.13199 13.7731C7.01127 13.7731 6.8952 13.7267 6.80234 13.6385C6.62127 13.4574 6.62127 13.1649 6.80234 12.9839L6.8627 12.9235C7.04377 12.7424 7.33627 12.7424 7.51734 12.9235C7.69842 13.1046 7.69842 13.3971 7.51734 13.5781L7.45699 13.6385C7.36877 13.7267 7.24806 13.7731 7.13199 13.7731ZM15.0898 10.4581H15.0527C14.7973 10.4581 14.5884 10.2492 14.5884 9.99386C14.5884 9.7385 14.7973 9.52958 15.0527 9.52958C15.3081 9.52958 15.5356 9.7385 15.5356 9.99386C15.5356 10.2492 15.3452 10.4581 15.0898 10.4581ZM5.84127 10.4581H5.80413C5.54877 10.4581 5.33984 10.2492 5.33984 9.99386C5.33984 9.7385 5.54877 9.52958 5.80413 9.52958C6.05949 9.52958 6.28699 9.7385 6.28699 9.99386C6.28699 10.2492 6.09663 10.4581 5.84127 10.4581ZM13.7016 7.2035C13.5809 7.2035 13.4648 7.15708 13.372 7.06886C13.1909 6.88779 13.1909 6.59529 13.372 6.41422L13.4323 6.35386C13.6134 6.17279 13.9059 6.17279 14.087 6.35386C14.2681 6.53493 14.2681 6.82743 14.087 7.0085L14.0266 7.06886C13.9384 7.15708 13.8223 7.2035 13.7016 7.2035ZM7.19234 7.2035C7.07163 7.2035 6.95556 7.15708 6.8627 7.06886L6.80234 7.00386C6.62127 6.82279 6.62127 6.53029 6.80234 6.34922C6.98342 6.16815 7.27592 6.16815 7.45699 6.34922L7.51734 6.40958C7.69842 6.59065 7.69842 6.88315 7.51734 7.06422C7.42913 7.15708 7.30842 7.2035 7.19234 7.2035ZM10.447 5.83386C10.1916 5.83386 9.9827 5.6435 9.9827 5.38815V5.351C9.9827 5.09565 10.1916 4.88672 10.447 4.88672C10.7023 4.88672 10.9113 5.09565 10.9113 5.351C10.9113 5.60636 10.7023 5.83386 10.447 5.83386Z",
    fill: "#838383"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dii_3417_109085",
    x: -0.695871,
    y: 0.249721,
    width: 22.2863,
    height: 22.2863,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.39286
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.39286
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3417_109085"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3417_109085",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.696429
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.348214
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "shape",
    result: "effect2_innerShadow_3417_109085"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.39286
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.696429
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_3417_109085",
    result: "effect3_innerShadow_3417_109085"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMood);
export default __webpack_public_path__ + "static/media/mood.f1f6553b113f81efb65046a4be2bde83.svg";
export { ForwardRef as ReactComponent };